const state = {
  adminGames: [],
  playBackground: false,
  playGame: null,
  flipmasterSettings: {},
  selectedProviders: [],
};

export default state;
